import TabsView from './TabsView.vue';
import TabsViewHeader from './TabsViewHeader.vue';

export default function({ path, viewConfig }) {
  let routes = [
    {
      path: `/${path}`,
      name: 'TabsView',
      meta: { moduleType: 'View', viewConfig, baseRoute: true },
      title: viewConfig.title,
      components: { default: TabsView, header: TabsViewHeader },
    },
  ];

  viewConfig.tabs.forEach((tab) => {
    routes.push({
      path: `/${path}/:tabIndex`,
      props: true,
      name: tab.title,
      meta: { moduleType: 'View', features: tab.features, baseRoute: false },
      components: { default: TabsView, header: TabsViewHeader },
    });
  });

  return routes;
}
